import lazyLoadOnRender from '../lazy/loadOnRender';

const OutageBanner = () => import(/* webpackChunkName: "4-feat-browser-deprecation-message" */ './OutageBanner');

export default lazyLoadOnRender({ loader: OutageBanner });
